var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"burger-menu-mobile",attrs:{"name":"Menu"},nativeOn:{"click":function($event){return _vm.revealBurgerMenu($event)}}},[_c('span',{staticClass:"burger-menu-mobile__title"},[_vm._v("\n        Menu\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }